import styled from '@emotion/styled';
import { ErrorsContextProvider, ValidationErrors } from 'components';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useLocation, useNavigate } from 'react-router';
import { Button, toast } from '@britishcouncil/react-admin';
import { useCallback, useEffect, useMemo } from 'react';
import { parseServerErrors } from 'utils';
import { speakingSessionStore } from 'store';

export const ReleaseSpeakingSession = () => {
  const sessionId = useIntParam('sessionId');
  const location = useLocation();
  const { speakingSessionDetails } = ROUTING_PATHS;
  const [releaseSession, { isSuccess, error: savingError, isLoading: isConfirming, reset }] =
    speakingSessionStore.service.useReleaseSpeakingSessionMutation();
  const navigate = useNavigate();
  const errors = useMemo(() => parseServerErrors(savingError), [savingError]);

  const goToSpeakingSessionDetails = useCallback(() => {
    navigate(generatePath(speakingSessionDetails.absolutePath, { sessionId }), {
      state: location.state,
    });
  }, [location.state, navigate, speakingSessionDetails.absolutePath, sessionId]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        type: 'success',
        title: 'Success',
        message: 'Session released successfully',
      });
      goToSpeakingSessionDetails();
      reset();
    }
  }, [goToSpeakingSessionDetails, isSuccess, sessionId, reset]);

  return (
    <ErrorsContextProvider generalErrors={errors}>
      <Modal open size="tiny">
        <Modal.Header>Release session</Modal.Header>
        <Modal.Content>
          <S.ValidationErrors />
          <p>Are you sure you want to release this Speaking Session?</p>
        </Modal.Content>

        <Modal.Actions>
          <Link
            to={generatePath(speakingSessionDetails.absolutePath, { sessionId })}
            state={location.state}
          >
            <Button compact type="reset" secondary>
              Cancel
            </Button>
          </Link>

          <Button
            compact
            color="blue"
            onClick={() => {
              releaseSession({ speakingSessionId: sessionId });
            }}
            loading={isConfirming}
            disabled={isConfirming}
          >
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
    </ErrorsContextProvider>
  );
};

const S = {
  ValidationErrors: styled(ValidationErrors)`
    &.ui.error.message {
      margin-bottom: 3rem;
    }
  `,
};
